// Generated by scripts/build-ui-icons.mjs.
export { CaretDoubleUp as default } from "../ui/glyphs-2";
